"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInvalidateManualReadingsLegacyQuery = exports.useManualReadingsLegacyQuery = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var date_fns_1 = require("date-fns");
var react_query_1 = require("react-query");
var core_1 = require("../../../core");
function cacheKey(accountId, msn, mpxn, fuel) {
    return "cx-manual-readings-".concat(accountId, "-").concat(msn, "-").concat(mpxn, "-").concat(fuel);
}
function useInvalidateManualReadingsLegacyQuery(accountId, msn, mpxn, fuel) {
    var queryClient = (0, react_query_1.useQueryClient)();
    return function () {
        return queryClient.invalidateQueries(cacheKey(accountId, msn, mpxn, fuel));
    };
}
exports.useInvalidateManualReadingsLegacyQuery = useInvalidateManualReadingsLegacyQuery;
function useManualReadingsLegacyQuery(_a, options) {
    var accountId = _a.accountId, msn = _a.msn, mpxn = _a.mpxn, fuel = _a.fuel, from = _a.from;
    var api = core_1.configService.getConfig().api;
    var queryString = new URLSearchParams({
        from: (0, date_fns_1.format)(from, 'yyyy-MM-dd').toString(),
    }).toString();
    var manualReadingsEndpoint = "".concat(api.baseUrl, "/rlc/rac-public-api/api/v5/supplypoints/").concat(fuel, "/").concat(mpxn, "/meters/").concat(msn, "/readings?").concat(queryString);
    return (0, ui_tools_1.useReactQuery)(
    // msn/mpxn can be shared across accounts, eg someone moves out and someone else moves into the same address
    cacheKey(accountId, msn, mpxn, fuel), function () { return core_1.apiService.get({ url: manualReadingsEndpoint }); }, options);
}
exports.useManualReadingsLegacyQuery = useManualReadingsLegacyQuery;
